/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * We use a single version for all components/artifacts. Both number or hash field should be unique for any given version, but we include them both for descriptive reasons.
 * @export
 * @interface Version
 */
export interface Version {
    /**
     * 
     * @type {number}
     * @memberof Version
     */
    major: number;
    /**
     * 
     * @type {number}
     * @memberof Version
     */
    minor: number;
    /**
     * 
     * @type {number}
     * @memberof Version
     */
    patch: number;
    /**
     * 
     * @type {number}
     * @memberof Version
     */
    revisionNumber: number;
    /**
     * The first few letters of this version's git commit hash.
     * @type {string}
     * @memberof Version
     */
    shortHash: string;
}

/**
 * Check if a given object implements the Version interface.
 */
export function instanceOfVersion(value: object): value is Version {
    if (!('major' in value) || value['major'] === undefined) return false;
    if (!('minor' in value) || value['minor'] === undefined) return false;
    if (!('patch' in value) || value['patch'] === undefined) return false;
    if (!('revisionNumber' in value) || value['revisionNumber'] === undefined) return false;
    if (!('shortHash' in value) || value['shortHash'] === undefined) return false;
    return true;
}

export function VersionFromJSON(json: any): Version {
    return VersionFromJSONTyped(json, false);
}

export function VersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Version {
    if (json == null) {
        return json;
    }
    return {
        
        'major': json['major'],
        'minor': json['minor'],
        'patch': json['patch'],
        'revisionNumber': json['revisionNumber'],
        'shortHash': json['shortHash'],
    };
}

export function VersionToJSON(json: any): Version {
    return VersionToJSONTyped(json, false);
}

export function VersionToJSONTyped(value?: Version | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'major': value['major'],
        'minor': value['minor'],
        'patch': value['patch'],
        'revisionNumber': value['revisionNumber'],
        'shortHash': value['shortHash'],
    };
}

